import ContentCreator from '../../../components/ContentCreator/ContentCreator';
import DeleteConfirmationModal from '../../../components/DeleteConfirmationModal/DeleteConfirmationModal';
import TanStackTable from '../../../components/Table/TanStackTable/TanStackTable';
import useCommunityForvet from '../../../hooks/Marketing/CommunityForvet/useCommunityForvet';
import CommunityResourceCard from './CommunityResourceCard';
import CommunityResourceForm from './CommunityResourceForm';
import CommunityStatsDashboard from './CommunityStatsDashboard';

export default function CommunityForvet() {
    const {
        isLoading,
        data,
        columns,
        editNew,
        handleSubmit,
        displayForm,
        setDisplayForm,
        initialValuesEdit,
        setInitialValuesEdit,
        deleteModalOpen,
        setDeleteModalOpen,
        setSelectedResourceId,
        deleteNew,
        formValidations,
        globalStats, 
        topResources
    } = useCommunityForvet()

    return (
        <section className='MktgNewsView-container'>
            {displayForm && (
                <ContentCreator
                    title={initialValuesEdit ? "Editar recurso" : "Crear recurso"}
                    submitFunc={(values) => handleSubmit(values)}
                    onCancel={() => {
                        setDisplayForm(false)
                        setInitialValuesEdit(null)
                    }}
                    initialValues={initialValuesEdit ?? {
                        is_active: true,
                        title: "",
                        description: "",
                        url: "",
                        image: ""
                    }}
                    validation={formValidations}
                    renderPreview={(_form) => (
                        <CommunityResourceCard item={_form.form.values} />
                    )}
                    renderForm={(_form) => (
                        <CommunityResourceForm form={_form.form} isLoading={isLoading} />
                    )}
                />
            )}

            {data && (
                <TanStackTable
                    loading={isLoading}
                    data={data}
                    columns={columns}
                    displayForm={displayForm}
                    editFunc={editNew}
                    onDelete={deleteNew}
                    addButtonFunc={() => {
                        setDisplayForm(!displayForm)
                        if (displayForm) setInitialValuesEdit(null)
                    }}
                />
            )}

            <DeleteConfirmationModal
                opened={deleteModalOpen}
                loading={isLoading}
                onClose={() => {
                    setDeleteModalOpen(false)
                    setSelectedResourceId(null)
                }}
                onCancel={() => {
                    setDeleteModalOpen(false)
                    setSelectedResourceId(null)
                }}
                onConfirm={deleteNew}
            />

           
            {!displayForm && data && (
                <CommunityStatsDashboard
                    globalStats={globalStats}
                    topResources={topResources}
                />
            )}

        </section>
    )
}





